import { Component, OnInit } from '@angular/core';
import { Inspection } from '../../shared/models/index';
import { InspectionModelService } from '../../shared/services/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './status.component.html',
    standalone: false
})
export class InspectionModelStatusPageComponent extends BaseModalPageComponent implements OnInit {
  inspection: Inspection;
  inspectionId: string;
  statusList: number[];

  constructor(
    private inspectionModelService: InspectionModelService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      let id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;
      this.initData();
    });
  }

  initData(): void {
    this.inspectionModelService.getModel(this.inspectionId).subscribe((el) => {
      this.inspection = el;
    });
    this.statusList = this.inspectionModelService.getStatusList();
  }

  updateStatus(inspection: Inspection): void {
    this.inspectionModelService.updateStatus(inspection.id, inspection.status).subscribe((el) => {
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }
}
